
const isValidImgExtentision = (extension) => {
    let allowedExtensions = /(jpg|jpeg|png)$/i;
    if(!allowedExtensions.exec(extension)) {
        alert('Sube un archivo con extension .jpeg .jpg .png');
        return false;
    }
    return true
}


export default isValidImgExtentision